import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { loginUser, logoutUser } from "../../../services/authService";

import Cookies from "js-cookie";
import { fetchUser, uploadProfileImage, fetchProfileImage, deleteProfileImage } from "../thunks/customerThunks";

const initialState = {
  accessToken: Cookies.get("accessTokenJKT") || null,
  role: Cookies.get("role") || null,
  loading: false,
  error: null,
  userInfo: null,
  profileUrl: null,
  profileLoading: false,
  isOtpVerified: false,
};

// Thunk for login
export const login = createAsyncThunk(
  "login/login",
  async ({ email, password }, { rejectWithValue }) => {
    try {
      return await loginUser(email, password);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const logout = createAsyncThunk(
  "login/logout",
  async (id, { dispatch }) => {
    await logoutUser(id);
    dispatch(authSlice.actions.clearAuthState());
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setOtpVerified: (state, action) => {
      state.isOtpVerified = action.payload;
    },
    resetOtpVerified: (state) => {
      state.isOtpVerified = false;
    },
    clearAuthState: (state) => {
      state.accessToken = null;
      state.role = null;
      state.userInfo = null;
      state.profileUrl = null;
      state.isOtpVerified = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.accessToken = action.payload.accessToken;
        state.role = action.payload.role;
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.loading = false;
        state.userInfo = action.payload;
      })
      .addCase(fetchUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(logout.fulfilled, (state) => {
        state.accessToken = null;
        state.role = null;
        state.profileUrl = null;
        state.isOtpVerified = false;
      })
      // Profile Image
      .addCase(fetchProfileImage.fulfilled, (state, action) => {
        state.profileUrl = action.payload?.profileUrl || null;
      })
      .addCase(uploadProfileImage.pending, (state) => {
        state.profileLoading = true;
      })
      .addCase(uploadProfileImage.fulfilled, (state, action) => {
        state.profileLoading = false;
        state.profileUrl = action.payload?.profileUrl || null;
      })
      .addCase(uploadProfileImage.rejected, (state) => {
        state.profileLoading = false;
      })
      .addCase(deleteProfileImage.fulfilled, (state) => {
        state.profileUrl = null;
      });
  },
});

export const { setOtpVerified, resetOtpVerified, clearAuthState } =
  authSlice.actions;
export default authSlice.reducer;
